import React from 'react'
import { GetId } from '@App/interfaces/get-id'

interface CardResultsTableProps<T> {
    data: T[]
    count: number
    cardType: React.ComponentType<T>
    noResultsInfo?: React.ReactNode
}

const CardResultsTable = <T extends GetId>(props: CardResultsTableProps<T>) => {
    const { data, count, cardType } = props
    const CardTypeComponent = cardType
    const noResultsInfo = props.noResultsInfo || <p className="small no-results bold">No results</p>
    return <>{count > 0 ? data.map((item: T) => <CardTypeComponent {...item} key={item.getId()} />) : noResultsInfo}</>
}

export default CardResultsTable
